<template>
  <page-view hide-navigation>
    <projects-section>
      <projects-list
        :items="projectItems"
        :visible="visible"
        @transitionEnd="setProjects"
      />
    </projects-section>
    <in-viewport><projects-pagination-container/></in-viewport>
  </page-view>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProjectsSection from '@/containers/Projects/ProjectsSection'
import ProjectsList from '@/containers/Projects/ProjectsList'
import ProjectsPaginationContainer from '@/containers/ProjectsPaginationContainer'

export default {
  components: {
    ProjectsSection,
    ProjectsList,
    ProjectsPaginationContainer
  },
  data () {
    return {
      visible: true,
      projectItems: []
    }
  },
  computed: {
    ...mapGetters(['link', 'projects'])
  },
  watch: {
    projects () {
      if (this.projectItems.length && this.visible) {
        this.visible = false
      } else {
        this.setProjects()
      }
    }
  },
  created () {
    this.fetchProjects()
    this.setProjects()
  },
  methods: {
    ...mapActions(['fetchProjects']),
    setProjects () {
      this.projectItems = this.projects.map(project => ({
        ...project,
        link: this.link({
          name: 'details',
          params: { id: project.slug ? `${ project.id }-${ project.slug }` : project.id }
        })
      }))

      this.$nextTick(() => {
        this.visible = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Projects/ProjectsContainer.vue